import React from 'react';
import {Route} from 'react-router-dom'
import Voter from '../voter'
import NoEvaluation from '../../components/noEvaluation'
import './app.css'

const App = () => (
    <div className="App">
        <Route path={`${process.env.PUBLIC_URL}/:hash`} component={Voter}/>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={NoEvaluation}/>
    </div>
)

export default App;


// WEBPACK FOOTER //
// ./src/containers/app/index.js